import lodash from 'lodash';
window._ = lodash;
window.lodash = lodash;
window.orderBy = lodash.orderBy;
